export const SET_REGISTRATION_TOKEN = "SET_REGISTRATION_TOKEN";
export const REGISTER_USER_START = "REGISTER_USER_START";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE";
export const REGISTRATION_TOKEN_CHECK_START = "REGISTRATION_TOKEN_CHECK_START";
export const REGISTRATION_TOKEN_CHECK_SUCCESS = "REGISTRATION_TOKEN_CHECK_SUCCESS";
export const REGISTRATION_TOKEN_CHECK_FAILURE = "REGISTRATION_TOKEN_CHECK_FAILURE";
export const USER_REGISTRATION_CONFIRM_START = "USER_REGISTRATION_CONFIRM_START";
export const USER_REGISTRATION_CONFIRM_SUCCESS = "USER_REGISTRATION_CONFIRM_SUCCESS";
export const USER_REGISTRATION_CONFIRM_FAILURE = "USER_REGISTRATION_CONFIRM_FAILURE";
